// Production: API on its own subdomain (separate IIS site). Cross-origin → CORS must allow this site's origin.
// NOTE: if this site is served over HTTPS, an http:// API will be blocked as mixed content — use https there.
export const environment = {
  production: true,
  apiBaseUrl: 'https://main-website-api.maven-merge.com/api'
};
